import { Card, CardContent, CardDescription, CardTitle } from '@/components/ui/card';

const services = [
  {
    title: 'Diagrammed Clarity Map',
    description:
      'A fixed-fee diagnostic for founders whose books, tools, and cash signals are no longer lining up cleanly.',
    tiers: 'Fixed-fee diagnostic',
  },
  {
    title: 'Async Prefit',
    description:
      'Start with written, non-sensitive context. No files, screenshots, exports, credentials, or private values before fit is clear.',
    tiers: 'Fit before calendar',
  },
  {
    title: 'Operator-Build Support',
    description:
      'When the diagnostic proves a build path, I can help shape reporting workflows, spreadsheet models, and lightweight internal tools.',
    tiers: 'After the map',
  },
];

export function ServicesGrid() {
  return (
    <section id="services" data-guide-label="Services" className="border-b border-ink/5 bg-paper">
      <div className="mx-auto max-w-5xl px-6 py-24">
        <div className="max-w-2xl">
          <p className="font-display text-xs uppercase tracking-[0.25em] text-accent">
            What I deliver
          </p>
          <h2 className="mt-3 font-display text-3xl tracking-tight md:text-4xl">
            One diagnostic, then the right next move.
          </h2>
          <p className="mt-4 text-ink/70">
            Built for side-project and non-FT work: bounded, async-first, and
            respectful of founder time on both sides.
          </p>
        </div>
        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {services.map((s) => (
            <Card key={s.title} className="flex flex-col">
              <CardContent className="flex-1 p-8">
                <p className="font-display text-xs uppercase tracking-[0.2em] text-accent">
                  {s.tiers}
                </p>
                <CardTitle className="mt-3">{s.title}</CardTitle>
                <CardDescription className="mt-4 text-base leading-relaxed">
                  {s.description}
                </CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
